
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pt/termos-condicoes",
      function () {
        return require("private-next-pages/pt/termos-condicoes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pt/termos-condicoes"])
      });
    }
  